import { render, staticRenderFns } from "./ShowAssociatedEntity.vue?vue&type=template&id=4bb47b75&scoped=true"
import script from "./ShowAssociatedEntity.vue?vue&type=script&lang=js"
export * from "./ShowAssociatedEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb47b75",
  null
  
)

export default component.exports